import React from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
} from '@mui/material';
import { Error as ErrorIcon } from '@mui/icons-material';
import Page from '../../components/Layout/Page';
import { useStyles } from './styles';

const WebpayError: React.FC = () => {
  const classes = useStyles();
  const { studentId } = useParams<{ studentId?: string }>();
  const history = useHistory();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const errorParam = searchParams.get('error');

  const getErrorMessage = (error: string | null): string => {
    switch (error) {
      case 'missing_token':
        return 'No se recibió el token de la transacción. Por favor, intenta realizar el pago nuevamente.';
      case 'payment_not_found':
        return 'No se encontró el pago asociado a esta transacción. Por favor, verifica el estado de tu pago o contacta con soporte.';
      default:
        return error || 'Ocurrió un error al procesar el pago. Por favor, intenta nuevamente o contacta con soporte.';
    }
  };

  const errorMessage = getErrorMessage(errorParam);

  return (
    <Page title="Error en el pago">
      <Box className={classes.container}>
        <Box style={{ textAlign: 'center', padding: '40px 20px' }}>
          <ErrorIcon
            style={{ fontSize: 80, color: '#f44336', marginBottom: 20 }}
          />
          <Typography variant="h4" style={{ marginBottom: 16, color: '#f44336' }}>
            Error al procesar el pago
          </Typography>
          <Typography variant="body1" style={{ marginBottom: 24, color: '#666' }}>
            {errorMessage}
          </Typography>
          <Box style={{
            display: 'flex',
            gap: 16,
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}
          >
            {studentId ? (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => history.push(`/inscripcion/alumno/${studentId}/pago`)}
                  size="large"
                >
                  Intentar nuevamente
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => history.push(`/inscripcion/alumno/${studentId}`)}
                  size="large"
                >
                  Volver al plan de estudios
                </Button>
              </>
            ) : (
              <Button
                variant="contained"
                color="primary"
                onClick={() => history.push('/inscripcion')}
                size="large"
              >
                Volver
              </Button>
            )}
          </Box>
        </Box>
      </Box>
    </Page>
  );
};

export default WebpayError;
